import * as BABYLON from '@babylonjs/core/Legacy/legacy';
import { Rectangle, Control, TextBlock } from '@babylonjs/gui/2D';
import { IElement2D } from './element'


export class EndText implements IElement2D {
    control: Control;
    constructor() {
        var text1 = new TextBlock();
        text1.text = "Game End";
        text1.color = "white";
        text1.fontSize = 30;
        this.control = text1
    }

    update() {

    }

    getControls(): Control[] {
        return [this.control];
    }
}